import { FaroSkeleton, FaroTable, FaroTableProps } from '@faro/design-system';
import { ReactNode } from 'react';
import styles from './StudyDefinitionTable.module.scss';

export function StudyDefinitionTableSkeleton(props: FaroTableProps): ReactNode {
    const { className = '', ref, ...rest } = props;
    return (
        <FaroTable
            {...rest}
            ref={ref}
            className={`
                ${styles.table}
                ${className}
            `}
            appearance="bordered-minimally-interactive"
        >
            <thead>
                <tr>
                    <th>
                        <FaroSkeleton height="lg" />
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>
                        <FaroSkeleton height="lg" />
                    </td>
                </tr>
                <tr>
                    <td>
                        <FaroSkeleton height="lg" />
                    </td>
                </tr>
                <tr>
                    <td>
                        <FaroSkeleton height="lg" />
                    </td>
                </tr>
            </tbody>
        </FaroTable>
    );
}
